import React from "react";
import { BrowserRouter, Routes, Route } from "react-router";
import PublicRoutes from "./routes/PublicRoutes";
import ProtectedRoutes from "./routes/ProtectedRoutes";
import AdminLogin from "./pages/AdminLogin";
import Contact from "./pages/Contact";
import { AxiosInterceptorSetup } from "./components/AxiosInterceptor";

import routes from "@/lib/routes";

import DashboardPage from "./components/dashboard/HomePage";
import CategoryPage from "./pages/dashboard/category";
import UsersPage from "./pages/dashboard/user";
import NotificationsPage from "./pages/dashboard/notification";
import AddNotification from "./pages/dashboard/notification/addNotification";
import AddPost from "./pages/dashboard/feed/addPost";
import ProductsPage from "./pages/dashboard/product";
import AddProduct from "./pages/dashboard/product/addProduct";

import { Toaster } from "@/components/ui/sonner";

import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

const App = () => {
  return (
    <>
      <BrowserRouter>
        <AxiosInterceptorSetup />
        <Toaster position="top-right" />
        <Routes>
          <Route element={<PublicRoutes />}>
            <Route index path="/" element={<AdminLogin />} />
            <Route index path="*" element={<AdminLogin />} />
            <Route index path="contact" element={<Contact />} />
            <Route index path="contact.html" element={<Contact />} />
          </Route>
          <Route element={<ProtectedRoutes />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            {routes.slice(1).map((item) =>
              // Dynamically generate routes based on routes
              item?.children ? (
                item.children.map((child) => (
                  <Route
                    key={child.path}
                    path={`/dashboard/${item.path}/${child.path}`}
                    element={child.element}
                  />
                ))
              ) : (
                <Route
                  key={item.path}
                  path={`/dashboard/${item.path}`}
                  element={item.element}
                />
              )
            )}
          </Route>
          {/* <Route element={<ProtectedRoutes />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/dashboard/category" element={<CategoryPage />} />
            <Route path="/dashboard/users/all-users" element={<UsersPage />} />
            <Route path="/dashboard/products/manage-product" element={<ProductsPage />} />
            <Route
              path="/dashboard/products/add-product"
              element={<AddProduct />}
            />
            <Route
              path="/dashboard/notifications"
              element={<NotificationsPage />}
            />
            <Route
              path="/dashboard/notifications/add-notification"
              element={<AddNotification />}
            />
            <Route path="/dashboard/feed/add-post" element={<AddPost />} />
          </Route> */}
        </Routes>
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen />
    </>
  );
};

export default App;
